'use client';
import { getItem } from '../../libs/encryptedStorage';
import { useRouter } from 'next/navigation';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginActions } from 'sharedresources';
import EmailLogin from "./emailLogin/page";
import { RootState } from 'sharedresources/src/redux/reducers';
import SpinWrapper from '../../components/SpinWrapper/page';
import { hasRoutePermission, getDefaultRoute } from '../../util/routePermissions';
const { validateUserLogin } = loginActions

const Login: React.FC = (props) => {

  const { firebase, isLoading } = useSelector((state: RootState) => state.login);
  const dispatch = useDispatch();
  const router = useRouter()
  const [userLoading, setUserLoading] = useState(true);
  const [isValidating, setIsValidating] = useState(false);
  const [emailLoginVisible, setEmailLogin] = useState(false);

  useLayoutEffect(() => {
    let userObj = getItem("user");
    if (userObj) {
      if (process.env.NODE_ENV !== "production") {
        dispatch(validateUserLogin({ noChannel: true }));
        setIsValidating(true);
      }
    }
    setUserLoading(false);
  }, []);

  useLayoutEffect(() => {
    if (firebase?.user && firebase?.schoolConfig) {
      setIsValidating(false);
      renderContent();
    }
  }, [firebase]);

  useLayoutEffect(() => {
    renderContent();
  }, [])

  const renderContent = () => {
    // if (userLoading) return null;
    const pathName = typeof window !== "undefined" ? window.location.pathname : "/";
    const search = typeof window !== "undefined" ? window.location.search : null;

    const redirectToPath = () => {
      if (pathName !== "/") {
        // Check if user has permission for the requested route
        if (hasRoutePermission(firebase, pathName)) {
          router.push(pathName + search);
        } else {
          // User doesn't have permission, redirect to default route they can access
          const defaultRoute = getDefaultRoute(firebase);
          router.push(defaultRoute);
        }
      } else {
        // No specific route requested, redirect to default route based on permissions
        const defaultRoute = getDefaultRoute(firebase);
        router.push(defaultRoute);
      }
    };

    if (process.env.NODE_ENV !== "production") {
      if (firebase?.user && firebase?.schoolConfig) {
        redirectToPath();
      } else if (!isValidating) {
        // return <EmailLogin />;
        setEmailLogin(true);
      }
    } else {
      const userObj = getItem("user");
      if (userObj) {
        redirectToPath();
      } else {
        setEmailLogin(true);
      }
    }
  };
  return (
    <div>
      <SpinWrapper spinning={userLoading}>
        {emailLoginVisible ? <EmailLogin /> : <p></p>}
      </SpinWrapper>
    </div>
  );
};
export default Login